import React from "react";
import ReactModal from "react-modal";
import styles from "./styles";
import VerifyOTP from "containers/VerifyOTP";
import get from "lodash/get";

const OTPModal = ({ showModal, ...props }) => {
  const useEnhancedOTP =
    get(props, "appSettings.generic.use_enhanced_otp") || false;
  const otpBoxes = {
    auto_submit: true,
    hide_default_submit_button: true
  };

  return (
    <ReactModal style={styles.otpModalStyle} isOpen={showModal}>
      <VerifyOTP
        {...props}
        isModal={true}
        otpBoxes={useEnhancedOTP ? otpBoxes : false}
      />
    </ReactModal>
  );
};

OTPModal.defaultProps = {
  showModal: false,
  closeModal: () => {},
  buttonTheme: {},
  onSuccess: () => {}
};

export default OTPModal;
